export const gitCommit = 'ea1170b3'
